import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesManagerService } from '../../../services/routes-manager.service';

const styles = {
  outline: ['btn-primary btn-md', 'btn_w shadow-none'],
  simple: ['btn-atras btn-link', ''],
};

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.css'],
})
export class CustomButtonComponent {
  @Input() label: string;
  @Input() set button_style(value: keyof typeof styles) {
    this.buttonStyle = (styles[value] || []).join(' ');
  }
  buttonStyle: string;

  @Input() newRoute?: any[];
  @Input() redirectUrl?: string;

  constructor(
    private router: Router,
    private routesManager: RoutesManagerService,
  ) {}

  handleClick() {
    if (this.newRoute !== undefined) {
      this.routesManager.setLocalRouteValue(this.newRoute[0]);
      this.router.navigate(this.newRoute);
    } else if (this.redirectUrl) {
      window.location.href = this.redirectUrl;
    }
  }
}
